import React, { useEffect, useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { useForm } from 'react-hook-form';
import { uploadSold } from '../../../actions/keyCodeActions';
import UploadSoldForm from './UploadSoldForm';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export interface UploadSoldProps {
  done: () => void;
  cancel: () => void;
}

function UploadSold({ done, cancel }: UploadSoldProps) {
  const { t } = useTranslation();
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const dispatch = useAppDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();
  const [soldFiles, setSoldFiles] = useState<any[]>([]);

  const addFiles = (files: any[]) => {
    setSoldFiles((prevFiles) => [...prevFiles, ...files]);
  };
  const removeFile = (file: any) => {
    setSoldFiles((prevFiles) => prevFiles.filter((prevFile) => prevFile !== file));
  };
  const onSubmit = (data: any) => {
    Promise.all(soldFiles.map((file) => uploadSold({ file, ...data })))
      .then(() => {
        toast.success(t('Sold keys successfully uploaded'));
        done();
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to upload sold keys'));
      });
  };

  useEffect(() => {
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
  }, [dispatch, keyProviders]);

  return (
    <SlideoutLayout title={t('Upload sold keys')} cancel={cancel}>
      <UploadSoldForm
        keyProviders={keyProviders}
        register={register}
        errors={errors}
        cancel={cancel}
        submit={handleSubmit(onSubmit)}
        addFiles={addFiles}
        removeFile={removeFile}
        files={soldFiles}
      />
    </SlideoutLayout>
  );
}

export default UploadSold;
